<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">{{$t('SLAReport')}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="report-filter">
                <!-- <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report" style="float:right" >Export Excel</v-btn>
                <v-btn color="primary" @click="getCrmData">{{this.$t("searchSender")}}</v-btn>
                <v-btn @click="clearAllFilters">{{this.$t("clearAllFilters")}}</v-btn> -->
              
                <v-form
                    ref="form">
                    <v-layout class="d-none">
                    
                        <v-spacer/>
                        </v-layout>
                        <v-layout class="filter" >
                            <v-flex xs3 class="mr-2 ml-2">
                                <v-text-field
                                        v-model="agentFilterValue"
                                        label="Agent email"
                                        placeholder="Agent email"
                                        clearable
                                        @change="handleChangeFilter()" 
                                />
                                
                            </v-flex>
                               <v-flex xs3 class="mr-2">
                                <v-text-field
                                        v-model="durationFilterValue"
                                        label="Reply duration greater than"
                                        placeholder="Type minutes"
                                        type="number"
                                        :min="1"
                                        @change="handleChangeDurationFilter()" 
                                        @keypress="filterDuration" 
                                />
                            </v-flex>
                            <v-flex xs3 class="mr-2">
                                <v-select
                                        v-model="interval"
                                        label="Assigned Time"
                                        :items="intervalList"
                                />
                            </v-flex>
                            <v-flex xs3 class="mr-2">
                                <DatePicker
                                        v-model="fromDate"
                                        label="From Date"
                                        @input="handleFromDateChange"
                                        :max="toDate"
                                        :disabled="interval !== 'custom'"
                                />
                            </v-flex>
                            <v-flex xs3 class="mr-2">
                                <DatePicker
                                        v-model="toDate"
                                        label="To Date"
                                        @input="handleToDateChange"
                                        :min="fromDate"
                                        :max="today"
                                        :disabled="interval !== 'custom'"
                                />
                            </v-flex>
                         
                            <!-- <v-flex xs3>
                                <v-select
                                        v-model="interval"
                                        label="Last Interactive Time"
                                        :items="intervalList"
                                />
                            </v-flex> -->
                        
                            <!-- <v-flex xs4>
                             
                            </v-flex> -->
                       
                    <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report" style="float:right" >Export Excel</v-btn>

                  
                </v-layout>
      </v-form>

            </v-card>
            <v-card class="my-3">
                <v-data-table
                        :items="dataTableSort"
                        :headers="headers"
                        :pagination.sync="pagination"
                        :total-items="total_reports"
                        :rows-per-page-items="rowsPerPageItems"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value">
                                <span v-if="header.$value">              
                                    {{header.$value(props.item)}}                
                                </span>
                                <span v-else>
                                    <span v-if="header.value == 'session_id'">
                                    <a target="_blank" :href="`/bot/${activeBot.code}/s/${props.item['sender_id']}`">{{props.item[header.value]}}</a>
                                    </span>
                                    <span v-else>{{props.item[header.value]}}</span>
                                </span>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:headers="props">
                        <tr>
                            <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="[
                                        'column sortable',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.value === pagination.sortBy ? 'active' : ''
                                    ]"
                                    @click="changeSort(header.value)"
                            >
                                <v-layout align-center style="height: 25px">
                                    <span>{{header.text}}</span>
                                    <v-menu open-on-hover bottom offset-y left v-if="header.tooltips">
                                        <template v-slot:activator="{ on }">
                                            <i class="mdi mdi-alert-circle info-icon ml-1" v-on="on"></i>
                                        </template>
                                        <div class="header-tooltips">
                                            <v-layout align-start>
                                                <v-icon small dark color="#4977EE" class="mr-1">
                                                    mdi-alert-circle
                                                </v-icon>
                                                {{header.tooltips}}
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Max</div>
                                                <div>{{max[header.value]}}</div>
                                            </v-layout>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Min</div>
                                                <div>{{min[header.value]}}</div>
                                            </v-layout>
                                        </div>
                                    </v-menu>
                                    <v-icon small>mdi-arrow-up</v-icon>
                                </v-layout>
                            </th>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import ReportService from '@/services/report.service'
import _ from 'lodash'
import moment from 'moment'
import DatePicker from '@/components/custom/DatePicker'
import BotService from '@/services/bot.service'
import {SocketMixin} from "@/mixins/SocketMixin";
import {mapState} from "vuex";
import utils from "@/services/utils";
import ActionTypes from "@/store/ActionTypes";
import StaffService from "@/services/staff.service";
export default {
        name: 'SLAReport',
        components: {DatePicker},
        mixins: [SocketMixin],
        data() {
            return {
                // supporterEmail: '',
                fromDate: moment().subtract(29, 'day').format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
                today: moment().format('YYYY-MM-DD'),
                slaConfig: {},
                supporter: 'all',
                channel: 'all',
                interval: '30days',
                activeBot: {},
                dataTable: [],
                durationFilterValue:'',
                agentFilterValue:'',
                assignTimeFilterValue:'',
                isAllSelected:false,
                isAllFilterSelected:false,
                total_reports: 0,
                intervalList: [
                    {text: 'Last 30 days', value: '30days'},
                    {text: 'Last 90 days', value: '90days'},
                    {text: 'Custom', value: 'custom'}
                ],
             
               
                showAllFilters: true,
                min: {},
                max: {},
                is_lock_report: false,
                channelList: [
                    {text: 'All', value: 'all'},
                ],

                pagination: {

                },
                rowsPerPageItems: [ 20, 50, 70, 100 ],
                loadingDialog: false,
                botList: [],
               
                headers: [
                    {
                        text: 'No',
                        value: 'index',
                        sortable: true
                    },
                    {
                      text: 'Requested time',
                      value: 'requested_time',
                      $value: item =>item.requested_time ? this.dateFormat(item.requested_time) : "",
                      sortable: true
                    },
                    {
                        text: 'Assign time',
                        value: 'assigned_time',
                        // filter: this.nameFilter,
                        $value: item =>item.assigned_time ? this.dateFormat(item.assigned_time) : "",
                        sortable: true
                    },
                    {
                        text: 'Customer name',
                        value: 'sender_name',
                        $value: item => item.sender_name,
                        sortable: true
                    },
                    {
                        text: 'Agent email',
                        value: 'agent_email',
                        sortable: true
                    },
                    {
                        text: 'Response time',
                        value: 'response_time',
                        // filter: this.nameFilter,
                        $value: item =>item.response_time ? this.dateFormat(item.response_time) : "--",
                        sortable: true
                    },
                    {
                        text: 'Reply duration',
                        // filter: this.nameFilter,
                        value: 'duration',
                        $value: item => {
                            
                            if (item.duration) {
                                return this.calculateReplyDuration(item.duration);
                            } else {
                                return "--";
                            }
                        },
                        sortable: true
                    },
                    {
                        text: 'Skill',
                        value: 'skill',
                        $value: item =>{
                            let skill=  item.skill && item.skill.length > 0 ? item.skill[0].name : "" ;
                            if (skill ===''){
                                if (item.type === 'specific') {
                                    skill = this.$t('noSkill');
                                }else{
                                    skill = '--';
                                }
                            }
                            return skill
                        },
                        sortable: true
                    },
                    {
                        text: 'Conversation',
                        value: 'session_id',
                        sortable: true
                    },
                    ],
            }
        },
        computed: {
            ...mapState(['notifyBotChat', 'user']),
            isValidTimeRangeFilter() {
                return moment.utc(this.toDate).diff(this.fromDate, 'days')  <= 90;
            },
            dataTableSort() {
                let clone = []
                if (this.dataTable.length) {
                    clone = [...this.dataTable]
                    clone = clone.map((items, index) => ({...items, index:  index + this.pagination.rowsPerPage*(this.pagination.page-1) + 1}))
                } else {
                    return []
                }
                if (this.pagination.sortBy) {
                    let header = _.find(this.headers, item => item.value === this.pagination.sortBy)
                    if(header){
                        return _.orderBy(
                            clone,
                            item => header.$value ? header.$value(item) : item[header.value],
                            this.pagination.descending ? 'desc' : 'asc'
                        )
                    }
                }
                return clone
            }
        },
        async mounted() {
            let has_permission = await this.hasPermission();
            if(has_permission){
                this.loadingDialog = true
                this.getListChannels()
                BotService.getAllBot().then(
                    result => {
                        this.botList = result.data;
                        let botCode = this.$route.params.botCode
                        if (botCode) {
                            let bot = _.find(this.botList, bot => bot.code === botCode)
                            if (bot) {
                                this.selectBot(bot)
                            } else {
                                this.loadingDialog = false
                                this.$router.push('/sla-report')
                            }
                        } else if (this.botList.length > 0) {
                            this.selectBot(this.botList[0])
                        } else {
                            this.loadingDialog = false
                        }
                    },
                ).catch(()=>{
                    this.$AppService.handleRequestError('can not get bot list')
                });
            }
            else{
                this.$router.push('/forbidden')
            }
        },
        methods: {
            async hasPermission(){
                return await StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
            },
            filterDuration: function(evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();
                
                if (!/^[1-9][0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            handleChangeFilter(){
                
                this.getSLAReport()
            },
            handleChangeDurationFilter(){
                this.durationFilterValue = parseInt(this.durationFilterValue)
                this.durationFilterValue = ( this.durationFilterValue < 1) ? 1 : this.durationFilterValue
                this.getSLAReport()
            },
            calculateReplyDuration(duration) {
                // const assignDate = new Date(assignTime);
                // const responseDate = new Date(responseTime);
                // const duration = responseDate - assignDate;

                if (isNaN(duration)) {
                    return "";
                }

                const seconds = duration;
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const remainingSeconds = seconds % 60;

                const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
                return formattedDuration;
            },
            async clearAllFilters() {
                //console.log(this.crmFilterValue)
                this.$refs.form.reset()
                //this.crmFilterValue=[]
                // this.getCrmData()
            },
            
            selectAllAttributes() {
            if (this.isAllSelected) {
                this.selectedTableAttributes = []
                this.selectedFilterAttributes = []
                this.isAllSelected = false
                this.isAllFilterSelected = false
            } else {
                this.selectedTableAttributes = []
                for (var att in this.crmSenderAttributes) {
                this.selectedTableAttributes.push(this.crmSenderAttributes[att].value)
                }
                this.isAllSelected = true
            }
            },
            selectAllFilterAttributes() {
            if (this.isAllFilterSelected) {
                this.selectedFilterAttributes = []
                this.isAllFilterSelected = false
            } else {
                this.selectedFilterAttributes = []
                for (var att in this.selectedTableAttributes) {
                this.selectedFilterAttributes.push(this.selectedTableAttributes[att])
                }
                this.isAllFilterSelected = true
            }
            },
            select(value) {
                this.selectedFilterAttributes = this.selectedFilterAttributes.filter(function(item){ 
                    return item != value;
                });

                if (this.selectedTableAttributes.length == this.crmSenderAttributes.length && this.selectedTableAttributes.length != 0) {
                    this.isAllSelected = true
                } else {
                    this.isAllSelected = false
                }
                this.selectFilter()
            },
            selectFilter(){
                if (this.selectedFilterAttributes.length == this.selectedTableAttributes.length && this.selectedFilterAttributes.length != 0) {
                    this.isAllFilterSelected = true
                } else {
                    this.isAllFilterSelected = false
                }
            },
            async cancel(){
                this.crmFieldSelect = false
                this.getSenderListConfig()
            },
            handleFromDateChange() {
                if (!this.isValidTimeRangeFilter) {
                    const maxAllowedToDate = moment.utc(this.fromDate).add(90, 'days');
                    this.toDate = maxAllowedToDate.toISOString().substr(0, 10);
                    
                }
                this.getSLAReport()

            },
            handleToDateChange() {
                if (!this.isValidTimeRangeFilter ) {
                    const minAllowedFromDate = moment.utc(this.toDate).subtract(90, 'days');
                    this.fromDate = minAllowedFromDate.toISOString().substr(0, 10);
                
                }
                this.getSLAReport()
            },
          
            calculateValue(item, i) {
              if (typeof item.topic === 'string' && i<0) {
                  return item.topic
              }
              else if (!!item.topic && typeof item.topic === 'object') {
                  return item.topic[`level_${i+1}`]
              }
              else {
                  return "";
              }
            },
            toISOString(date, startOfDay) {
                return startOfDay ? moment.utc(date).startOf('day').toISOString() : moment(date).endOf('day').toISOString()
            },
            dateFormat(date) {
                let formatedDate = moment.utc(date).utcOffset(7).format('DD-MM-YYYY HH:mm:ss')
                let momentDate = moment.utc(formatedDate,'DD-MM-YYYY HH:mm:ss')
                return momentDate.isValid() ? formatedDate : ""
            },
            channelFormat(channel){
                return this.stringFormat( this.$t(channel))
            },
            stringFormat(string){
                if(string){
                    string = string.split("_");
                    for (var i = 0, x = string.length; i < x; i++) {
                                string[i] = string[i][0].toUpperCase() + string[i].substr(1);
                    }
                    string = string.join(" ");
                }
                
                return string
            },
            getListChannels() {
                BotService.getListChannels(this.$route.params.botCode).then((list_channels) => {
                    this.channelList = utils.smoothListChannels(list_channels.data.channels);
                    for(const channel in this.channelList){
                        this.channelList[channel] = {text: this.channelFormat(this.channelList[channel]), value: this.channelList[channel]}
                    }
                });
            },
            changeBot(bot) {
                this.crmHeaders = []
                // this.selectedTableAttributes = []
                this.isAllSelected = false
                this.botCode = bot.code
                this.is_lock_report = false
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/sla-report/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot
                this.getSLAConfigs()
                this.getSLAReport()
            },
            changeSort(headerValue) {
                let pagination = {...this.pagination}
                if (pagination.sortBy === headerValue) {
                    pagination.descending = !this.pagination.descending
                } else {
                    pagination.sortBy = headerValue
                    pagination.descending = true
                }
                this.pagination = pagination
                setTimeout(() => {
                    this.$forceUpdate()
                }, 2000)
            },
            async exportExcel() {
                ReportService.SLAExcel(
                    this.activeBot.code, this.agentFilterValue, this.durationFilterValue * 60, 
                    this.toISOString(this.fromDate, true), this.toISOString(this.toDate), 
                    this.pagination.sortBy !== 'index' ? this.pagination.sortBy : null, this.pagination.descending)
                    .then((response) => {
                        const link = document.createElement('a');
                        const downloadLink = response.data.url;

                        link.href = downloadLink;
                        link.download = '';
                        link.style.display = 'none'; // Ẩn phần tử <a>
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Sau khi tải xuống, loại bỏ phần tử <a>
                        this.$AppService.toastSuccess(this.$t("reportSuccess"))
                        // this.is_lock_report = true
                    }).catch(()=> {
                        this.$AppService.toastError(this.$t("reportFailed"));
                    });
            },
            async getSLAConfigs (){
                BotService.getSLAConfigs(this.activeBot.code).then((response)=>{
                    if(response.data){
                        this.slaConfig = response.data
                    }
                    
                }).catch(()=> {
                        this.$AppService.toastError(this.$t("getSLAConfigFailed"));
                    });
            },
            async getSLAReport(){
                if(this.activeBot && this.activeBot.code){
                    try {
                    
                    const response = await ReportService.getSLAList(
                        this.activeBot.code, this.agentFilterValue, this.durationFilterValue * 60, 
                        this.toISOString(this.fromDate, true), this.toISOString(this.toDate), 
                        this.pagination.page, this.pagination.rowsPerPage, 
                        this.pagination.sortBy !== 'index' ? this.pagination.sortBy : null, this.pagination.descending
                    );
                    if (response.data && response.data.results) {
                        this.total_reports = response.data.count;
                        this.dataTable = response.data.results.sort((a, b) => {
                            return new Date(b.assigned_time) - new Date(a.assigned_time);
                        });
                    }
                } catch (error) {
                    console.log (error)
                    this.$AppService.toastError(this.$t("getSLAReportFailed"));
                } finally {
                    this.loadingDialog = false;
                }
                }
                
            }
        },
        watch: {
            interval(val) {
                let get_statistic = false
                switch (val) {
                    case '30days':
                        this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    case '90days':
                        this.fromDate = moment().subtract(89, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break    
                    default:
                        break
                }
                

            },
            pagination: {
              handler() {
                  this.getSLAReport()
              }
            },
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    this.getListChannels()
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                    }
                }
            },
            notifyBotChat(val) {
                if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.SESSION_REPORT_STATUS) {
                    if (val.data.is_success) {
                        this.$AppService.toastSuccess(this.$t("excelsReportSuccess"))
                    }
                    else {
                        this.$AppService.handleRequestError(this.$t("excelsReportFailed"))
                    }
                    this.is_lock_report = false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
    .modal .container{
        padding: 1px;
    }
    .overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    }

    .modal {
    position:absolute;
    margin:0 auto;
    left:0;
    right:0;
    top:20%;
    width:100%;
    max-width:40%;
    height:520px;
    background-color:#fff;
    z-index: 9999;
    padding:20px;

    max-height:520px
    }

    .close{
    position: absolute;
    top: 10px;
    right: 10px;
    }

    ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 300px;
    }

    input {
    margin-right: .5em;
    }
    div.scroll {
        margin:4px, 4px;
        padding:4px;
        width: 600px;
        height: 400px;
        z-index: 9999;
        overflow-x: hidden;
        overflow-y: auto;
        text-align:justify;
    }
    // .filter {
    //     display: flex;
    //     flex-wrap: wrap;
    // }
    // .filter>* {
    //     flex: 0 0 20%; 
    //     padding-left : 0.5% !important;
    //     padding-right: 0.5% !important;
    // }
    /* Create two equal columns that floats next to each other */
    .custom-column {
    float: left;
    width: 50%;
    padding: 10px;
    height: 100%; /* Should be removed. Only for demonstration */
    }

    /* Clear floats after the columns */
    .custom-row:after {
    content: "";
    display: table;
    clear: both;
    }
    .container-checkbox {
    display: block;
    position: relative;
    padding-left: 0px;
    padding-bottom: 15px;
    cursor: pointer;
    font-size: 15px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .container-checkbox:hover input ~ .checkmark {
    background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container-checkbox input:checked ~ .checkmark {
    background-color: #4977ee;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    }

    /* Show the checkmark when checked */
    .container-checkbox input:checked ~ .checkmark:after {
    display: block;
    }

    /* Style the checkmark/indicator */
    .container-checkbox .checkmark:after {
    left: 7px;
    top: 3px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    }
    #rcorners {
    border-radius: 7px;
    border: 2px solid #4977ee;
    padding: 20px; 
    
    }
    .table {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    border-collapse: collapse;
    width: 100%;
    }

    .table td,
    .table th {
    border: 1px solid #ddd;
    padding: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    font-size: 15px;
    }
    .table thead th {
    border: 1px solid #ddd;
    padding: 4px;
    padding-top: 6px;
    padding-bottom: 5px;
    text-align: center;
    font-size: 15px;
    }
    .table .container-checkbox {
        float: center;
    }
    table.table tbody tr.selected {
    background-color: #f2f2f2;
    }
    .table th{
        background-color: #4977ee;
        color: white;
        z-index: 99;
        text-align: center;

    }
    .table tr:hover {
    background-color: #ddd !important;
    }

      .tableFixHead {
        overflow-y: auto; /* make the table scrollable if height is more than 200 px  */
        height: 350px; /* gives an initial height of 200px to the table */
      }
      .tableFixHead thead th {
        position: sticky; /* make the table heads sticky */
        top: 0px; /* table head will be placed from the top of the table and sticks to it */
      }

</style>